import { IForm } from '@hooks/useForm';
import { ILoading } from '@hooks/useLoading';
import { IStepper } from '@hooks/useStepper';
import { ICliente } from '@model/Cliente';
import { IComboClienteTipo } from '@model/ClienteTipo';
import { IComboTipoCobrancaChip, IContratoCliente } from '@model/ContratoCliente';
import { IComboContratoOperadora } from '@model/ContratoOperadora';
import ILinha from '@model/Linha';
import React from 'react';
import { PageBox } from '../PageBox';
import { ResumoCommand } from './ResumoCommand';
import { ResumoInfo } from './ResumoInfo';

export type HomeContratoResumoProps = {
    stepper: IStepper
    loading: ILoading
    linhaForm: IForm<Partial<ILinha>>
    clienteForm: IForm<Partial<ICliente>>
    contratoForm: IForm<Partial<IContratoCliente>>
    contratoOperadoraCombo: IComboContratoOperadora
    clienteTipoCombo: IComboClienteTipo
    tipoCobrancaChipCombo: IComboTipoCobrancaChip
    onFinished: (contratoCliente: IContratoCliente) => void
}

export function HomeContratoResumo ({ linhaForm, clienteForm, contratoForm, stepper, loading, contratoOperadoraCombo, clienteTipoCombo, tipoCobrancaChipCombo, onFinished }: HomeContratoResumoProps) {
    return (
        <React.Fragment>
            <PageBox>
                <ResumoInfo 
                    linha={linhaForm.getValues()}
                    cliente={clienteForm.getValues()}
                    contrato={contratoForm.getValues()}
                    contratoOperadoraCombo={contratoOperadoraCombo}
                    clienteTipoCombo={clienteTipoCombo}
                    tipoCobrancaChipCombo={tipoCobrancaChipCombo}
                />
            </PageBox>

            <ResumoCommand
                linhaForm={linhaForm}
                clienteForm={clienteForm}
                contratoForm={contratoForm}
                stepper={stepper}
                loading={loading}
                onFinished={onFinished}
            />
        </React.Fragment>
    )
}